/* eslint-disable import/no-extraneous-dependencies */
import { DehydratedState, HydrationBoundary, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Theme } from '@tvg/fuse/theme';
import { PageType, PLPURL } from '@tvg/product-listing-url';
import Main from 'client/pages/Main';
import React, { useMemo } from 'react';
import ErrorBoundary from './pages/ErrorBoundary/ErrorBoundary';
import { GlobalConfigProvider } from './state/GlobalConfig/GlobalConfig';
import { MainStoreProvider } from './state/Main';

export interface AppProps {
  pageType: PageType;
  brand: string;
  apiURL: string;
  envURL: string;
  queryClient: QueryClient;
  isLocal: boolean;
  queryState?: DehydratedState;
  plpurl: PLPURL;
  isUnknowCustomer?: boolean;
}

export default function App({
  pageType,
  apiURL,
  brand,
  envURL,
  queryClient,
  isLocal,
  queryState,
  plpurl,
  isUnknowCustomer,
}: AppProps) {
  const globalConfig = useMemo(
    () => ({ pageType, apiURL, brand, envURL, isLocal, isUnknowCustomer }),
    [apiURL, brand, envURL, isLocal, pageType, isUnknowCustomer],
  );
  return (
    <ErrorBoundary>
      <GlobalConfigProvider value={globalConfig}>
        <MainStoreProvider plpURL={plpurl}>
          <QueryClientProvider client={queryClient}>
            <HydrationBoundary state={queryState}>
              <Theme brand={brand} />
              <Main />
            </HydrationBoundary>
            <ReactQueryDevtools />
          </QueryClientProvider>
        </MainStoreProvider>
      </GlobalConfigProvider>
    </ErrorBoundary>
  );
}
